import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";

const Item = ({
  item,
  handleCheckBoxClick,
  isCheck,
  moduleConfig,
  confirmAndDelete,
  confirmAndBlock,
  confirmAndUnblock,
  customButtonsForItems,
  loading,
}) => {
  const getItems = () => {
    let items = [];
    if (item.employmentType) {
      items = [
        ...items,
        {
          text: "Employment Type",
          value: item.employmentType,
          type: "text",
        },
      ];
    }

    return items;
  };
  return (
    <Card className="item mb-2">
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            {/* <div className="checkboxCol me-2 ms-2 mt-2">
              <input
                type="checkbox"
                id={item._id}
                name={item._id}
                onChange={handleCheckBoxClick}
                checked={isCheck.includes(item._id)}
              />
            </div> */}

            <div className="position-relative ms-2 mt-1 me-2">
              <i
                className={`fas fa-bell position-relative usericon`}
                style={{ fontSize: "30px" }}
              ></i>
            </div>

            <div className="d-flex flex-column align-content-center justify-content-center ms-1">
              <span className="m-0 text-bold text-custom-2">
                Send to - {item.to}{" "}
              </span>
              <span className="text-custom-4 mt-1 small text-bold">
                {item.type}
                <span className="text-custom-3 mt-1 ms-1 small">
                  ({item.admin?.firstName} {item.admin?.lastName})
                </span>
              </span>
            </div>
          </div>
        </Card.Title>

        <div className="card-tools">
          <div className="mt-1">
            {item.importance === "Low" && (
              <span className="badge badge-pill badge-custom-6 text-dark me-1">
                Low Importance
              </span>
            )}
            {item.importance === "Medium" && (
              <span className="badge badge-pill  badge-custom-7 me-1">
                Medium Importance
              </span>
            )}
            {item.importance === "High" && (
              <span className="badge badge-pill badge-custom-3 me-1">
                High Importance
              </span>
            )}
            {item.isProcessed === "1" && (
              <span className="badge badge-pill badge-info me-1">
                Completed
              </span>
            )}
            {item.isProcessed === "0" && (
              <span className="badge badge-pill badge-warning me-1">
                Processing
              </span>
            )}
            <span className="badge badge-light me-1 text-dark">
              Send Date/Time :{" "}
              <span className="text-secondary">
                <ModuleDisplayDateTime value={item.createdAt} />{" "}
              </span>
            </span>
          </div>

          <div className=" text-right me-xl-2  mt-1 mb-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title="View Item details"
            >
              <i className="fas fa-eye"></i>
            </Link>

            {/* <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title="Update Item"
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title="Block Item"
                onClick={() => confirmAndBlock(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title="Remove Ban"
                onClick={() => confirmAndUnblock(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )} */}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        {/* <Row>
          <Col md={12} className="mt-1 mb-1">
            <StatsListing items={getItems()} />
          </Col>
        </Row> */}
        {item.message && (
          <Alert className="alert-custom-3 m-1 px-1 py-0 font-small">
            <span className="text-bold ">Message : </span>
            {item.message}
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
};

export default Item;
